import { importDiagnosticText } from './ImportConfirmationStatus'

export default function ImportDiagnostics({ errors, warnings, rows }: {
  errors: unknown[]; warnings: unknown[]
  rows: Array<{ key: string; name: string; errors?: unknown[] }>
}) {
  return <section className="bg-white rounded-xl shadow-card p-5">
    <h2 className="font-heading font-semibold text-text-primary">Diagnostics</h2>
    {errors.length > 0 && <div className="mt-3 text-sm text-pinnacle-red">
      <h3 className="font-semibold">Blocking validation errors</h3>
      <ul className="mt-2 space-y-2">{errors.map((error, index) => <li key={index}>{importDiagnosticText(error)}</li>)}</ul>
      <a href="#import-mapping" className="block mt-3 underline">Review mappings and consents</a>
      {rows.filter(row => row.errors?.length).map(row => <a key={row.key} className="block mt-2 underline" href={`#import-row-${row.key}`}>Review {row.name || row.key}</a>)}
    </div>}
    {warnings.length > 0 && <div className="mt-4 text-sm text-text-secondary">
      <h3 className="font-semibold">Informational warnings — not blockers</h3>
      <ul className="mt-2 space-y-2">{warnings.map((warning, index) => <li key={index}>{importDiagnosticText(warning)}</li>)}</ul>
    </div>}
    {!errors.length && !warnings.length && <p className="mt-3 text-sm">No diagnostics reported.</p>}
  </section>
}
